import { Navigate, Outlet } from "react-router-dom";
import { LOGIN_PAGE } from "../constants/definitions";

interface PrivateRouteProps {
  cognitologin: any; // CognitoLoginClass
}

const PrivateRoute = (props: PrivateRouteProps) => {
  if (!props.cognitologin.isAuthenticated()) {
    return (
      <Navigate to={{ pathname: LOGIN_PAGE }} state={{ from: LOGIN_PAGE }} />
    );
  }

  return <Outlet />;
};

export { PrivateRoute };
